import { ReactNode } from 'react';
import { PermissionsTabProvider } from '@ciandtspike.io/plugin-ciandtspike-marketplace';
import {
  ManageAccessButton,
  EntityPermissionsTab,
} from '@internal/plugin-rebac-explorer-frontend';
import { useRolloutFlag, PERMISSIONS_TAB_FLAG } from '../../featureFlags';

// Espelha PermissionsTabContextValue do pacote marketplace, que não exporta o tipo.
interface PermissionsTabValue {
  renderPermissionsTab?: (opts: { resourceType: string; resourceId: string }) => ReactNode;
  renderTemplateManageButton?: (opts: { templateId: string }) => ReactNode;
  renderResourceManageButton?: (opts: { resourceType: string; resourceId: string; label?: string }) => ReactNode;
}

export function buildPermissionsTabValue(enabled: boolean): PermissionsTabValue {
  if (!enabled) return {};
  return {
    renderPermissionsTab: ({ resourceType, resourceId }) => (
      <EntityPermissionsTab resourceType={resourceType} resourceId={resourceId} />
    ),
    renderTemplateManageButton: ({ templateId }) => (
      <ManageAccessButton resourceType="template" resourceId={templateId} />
    ),
    renderResourceManageButton: ({ resourceType, resourceId, label }) => (
      <ManageAccessButton resourceType={resourceType} resourceId={resourceId} label={label} />
    ),
  };
}

// Marketplace não pode importar rebac-explorer-frontend diretamente (proibido entre
// plugins frontend), então o app injeta os componentes concretos via context aqui.
export const PermissionsTabBridge = ({ children }: { children: ReactNode }) => {
  const enabled = useRolloutFlag(PERMISSIONS_TAB_FLAG);
  return (
    <PermissionsTabProvider value={buildPermissionsTabValue(enabled)}>
      {children}
    </PermissionsTabProvider>
  );
};
